import axios from 'axios';

const api = axios.create({
  baseURL: '/api',
});

export const getPositions = () => api.get('/positions');
export const getPosition = (id) => api.get(`/positions/${id}`);
export const getRuleSet = () => api.get('/rule-set');
